<template>
    <div class="column-layout">
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="mt5" v-if="!readFlag">
            <button class='swb-btn swb-btn-mini mb10 fr' @click="markMsgGroupAsRead()">全部已读</button>
            <button class='swb-btn swb-btn-mini mr10 fr' @click="getXMsgList()">刷新</button>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="xMsgList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column width="180" label="单据号" show-overflow-tooltip v-if="fieldx != 'notice' && fieldx != 'staff.quali'">
                    <template slot-scope="rows">
                        <!--  || rows.row.fieldx == 'pay.voucher' || rows.row.fieldx == 'refund.voucher' 支付，退款暂不支持跳转 -->
                        <span class="swb-btn-link" v-if="rows.row.group == 'voucher' && (rows.row.fieldx == 'deal.inqry' || rows.row.fieldx == 'price.reply' || rows.row.fieldx == 'tend.bid' || rows.row.fieldx == 'contract' || rows.row.fieldx == 'goods.ship' || rows.row.fieldx == 'servc.reqr' || rows.row.fieldx == 'servc.order' || rows.row.fieldx == 'servc_work')" @click="toVoucherInfo(rows.row.fieldx, rows.row.fieldy,  rows.row.data)">{{rows.row.fieldy}}</span>
                        <span v-else-if="rows.row.group == 'voucher'">{{rows.row.fieldy}}</span>
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column width="220" label="标题" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <a v-if="rows.row.url != null && rows.row.type == 0" class="swb-btn-link" @click="toContractList(rows.row);">{{rows.row.txt}}</a>
                        <span v-else>{{rows.row.txt}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="内容" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.data != null && rows.row.data.indexOf('{') >= 0">{{ JSON.decode(rows.row.data).message }}</span>
                        <span v-else>{{rows.row.data}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="图片" align="center" width="70">
                    <template slot-scope="rows">
                        <span v-if="rows.row.url != null" @click="showImg(rows.row.url)">
                            <img :src="rows.row.url"/>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="senderName" label="发信者" width="220" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sendTime" width="180" label="发送时间" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{rows.row.sendTime.replace('.000', '')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="caozuo" width="80" align="center" label="操作">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" @click="msgInfo(rows.row)">查看</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import appConf from '../../app.conf';
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { voucherType } from '../../../resc/app/js/voucherType'
    import { getVoucherTypes } from '../../app.const'
    import userApi from '../../api/user'

    // --------------- 合同 -------------
    import SwbServcPurchContractList from '../contract/ServcPurchContractList'; // 服务采购合同
    Routes.add(SwbServcPurchContractList);
    import SwbIntegPurchContractList from '../contract/IntegPurchContractList'; // 集成采购合同
    Routes.add(SwbIntegPurchContractList);
    import SwbServcDlgtContractList from '../contract/ServcDlgtContractList'; // 服务授权合同
    Routes.add(SwbServcDlgtContractList);

    // -------------- 报价单 ---------------
    import SwbPriceReplyList from '../priceReply/PriceReplyList';
    Routes.add(SwbPriceReplyList);

    // ------------- 投标书 ----------------
    import SwbBidDocList from '../callbid/BidDocList';
    Routes.add(SwbBidDocList);

    // ----------------- 发货单 ------------
    import SwbGoodsShipVoucherList from '../order/GoodsShipVoucherList';
    Routes.add(SwbGoodsShipVoucherList);

    // ----------------- 服务请求单 ------------
    import SwbServcReqVoucherList from '../servcReq/ServcReqVoucherList';
    Routes.add(SwbServcReqVoucherList);

    // ----------------- 服务派工单 ------------
    import SwbServcWorkVoucherList from '../workVoucher/ServcWorkVoucherList';
    Routes.add(SwbServcWorkVoucherList);

    // ----------------- 收款单据 --------------
    import SwbRcvVoucherList from '../payment/RcvVoucherList';      // 收款单据
    Routes.add(SwbRcvVoucherList);

    // ----------------- 退款单据 --------------
    import SwbRefundVoucherList from '../payment/RefundVoucherList'; // 供应商退款单据
    Routes.add(SwbRefundVoucherList);

    // ------------- 授权服务列表 ----------
    // 授权服务列表问题： 未找到工程师时给调度员发送站内信，目前 服务订单类型 仅有 授权服务 发送站内信！
    import SwbServcOrderTradeList from '../servcOrder/ServcOrderTradeList';
    Routes.add(SwbServcOrderTradeList);

    import SwbServicerNoticeView from '../servicer/ServicerNoticeView'
    Vue.regist(SwbServicerNoticeView);
    let searchConfigData = {
        "queryFields": [
            {
                "type": "Select",
                "label": "主题",
                "code": "selectFieldx",
                "basic": true,
                "valueType": "String",
                "dataList": [{
                    "value": null,
                    "label": "全部"
                }]
            },
            {
                "type": "Text",
                "label": "标题",
                "code": "txt",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Date2",
                "label": "发送时间",
                "code": "sendTime",
                "basic": true,
                "valueType": "String"
            }
        ],
        "sortFields": []
    };
    export default{
        name: 'swb-receiver-msg-list',
        desc: '接收消息列表',
        props: {
            refreshUnreadMsgCount: {
                type: Function
            },
            readFlag: {
                type: Boolean,
                default: true,
            }
        },
        data: function () {
            return {
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                xMsgList: [],
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                fieldx: "notice",
                source: null,
                txt: null,
                timeScope: null,
                //
                voucherTypes: [],
                sourceFlag: [],
                theLoad: null,
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            // 获取站内信的业务场景/来源
            let voucherTypeList = Object.entries(getVoucherTypes());
            let voucherTypes = [];
            voucherTypes.push({"value": null, "label": "全部"});
            if(voucherTypeList != null && voucherTypeList.length > 0) {
                voucherTypeList.forEach(function (item) {
                    let queryItem = {};
                    queryItem.value = item[0];
                    queryItem.label = item[1];
                    voucherTypes.push(queryItem);
                })
            }
            let queryConfig = searchConfigData;
            let queryConfigMap = queryConfig.queryFields.toMap("code");
            let fieldxList = queryConfigMap['selectFieldx'];
            fieldxList.dataList = voucherTypes;
            this.queryConfig = Utils.merge({}, queryConfig);
            //
            this.sourceFlag = getEnumList("sourceFlag");
            //
            this.getXMsgList();
        },
        watch: {
            readFlag: function (newVlaue, oleVlaue) {
                if(newVlaue != oleVlaue) {
                    this.getXMsgList();
                }
            }
        },
        methods: {
            handleSizeChange(val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                //console.log("新页码：" + newPageNumber);
                this.handlePageChange(newPageNumber);
            },
            handlePageChange(val) {
                this.pageNumber = val;
                //
                this.getXMsgList();
            },
            queryHandler: function (queryModel) {
                this.pageNumber = 1;
                this.queryModel = queryModel;
                this.getXMsgList();
            },
            getXMsgList: function () {
                let self = this;
                let pageSize = self.pageSize;
                let pageNumber = self.pageNumber;
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if(!Utils.isNoB(filterItems.selectFieldx) && filterItems.selectFieldx != "null") {
                    filterItems.fieldx = filterItems.selectFieldx;
                }
                filterItems.readFlag = self.readFlag;
                this.theLoad = MsgBox.loading();
                MsgClient.setMsgsForReceiverHandler(self.renderReceiverMsgList);
                MsgClient.fetchMsgsForReceiver(pageNumber, pageSize, filterItems);
            },
            renderReceiverMsgList: function (msgsResult) {
                this.xMsgList = msgsResult.rows || [];
                //结果应用
                let pagination = msgsResult.pagination;
                this.totalCount = pagination.totalCount;
                this.pageNumber = pagination.pageNumber;
                this.pageSize = pagination.pageSize;
                //
                this.theLoad.hide();
            },
            // 当前分组（filedx）设置为全部已读
            markMsgGroupAsRead: function () {

                MsgClient.markMsgGroupAsRead(null);
                //
                this.getXMsgList();
            },
            msgInfo: function (row) {
                let self = this;
                MsgClient.markMsgAsRead(row.id);
                if(!Utils.isNoB(row.fieldx) && row.fieldx == 'notice') {
                    let noticeId = row.fieldy;
                    Vue.$showDialog({
                        title: "通知 - 查看",
                        width: 1200,
                        height: 750,
                        okVisible: false,
                        showCloseBtn: true,
                        okClicked: false,
                        cancelText: '关闭',
                        template: '<div>' +
                        '<swb-servicer-notice-view :id="id" :showTag="false" :noEditor="true"  ref="swb_servicer_notice_view"></swb-servicer-notice-view>' +
                        '</div>',
                        data: {
                            id: noticeId,
                        }
                    });
                } else {
                    Vue.$showDialog({
                        title: '查看站内信',
                        showCloseBtn: true,
                        okVisible: false,
                        cancelText: '关闭',
                        height: 650,
                        template: '<div>' +
                        '<div class="form-row spacing">' +
                        '<div class="form-label" style="width: 62px">' +
                        '<label>标题:</label>' +
                        '</div>' +
                        '<div class="form-value flex">' +
                        '<label>{{txt}}</label>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-row spacing">' +
                        '<div class="form-label" style="width: 62px">' +
                        '<label>内容:</label>' +
                        '</div>' +
                        '<div class="form-value flex" v-if="isJson">{{JSON.decode(jsonData).message}}</div>' +
                        '<div class="form-value flex" v-else>{{jsonData}}</div>' +
                        '</div>' +
                        '<div class="form-row spacing" v-if="type == 1">' +
                        '<div class="form-label" style="width: 62px">' +
                        '<label>图片:</label>' +
                        '</div>' +
                        '<div class="form-value flex" v-if="url != null"><img style="width:200px; height: 200px;" :src="url"/></div>' +
                        '</div>' +
                        '</div>',
                        data: {
                            jsonData: row.data || '',
                            isJson: (row.data || '').startsWith('{') && (row.data || '').endsWith('}'),
                            txt: null,
                            type: row.type,
                            url: row.url,
                        },
                        methods: {},
                        okClicked: function () {
                        },
                        lifecycle: {
                            created: function () {
                                let selfDlg = this;
                                selfDlg.txt = row.txt;
                            }
                        }
                    });
                    self.getXMsgList();
                }
            },
            doOnMsgRead: function (msgData) {
                //
                var unread = msgData.unread;
                this.refreshUnreadMsgCount.call(parent, unread);
            },
            toContractList: function (row) {
                Utils.setPageUrl(row.url, '_blank');
            },
            // 各种单据跳转
            toVoucherInfo: function (type, no, data) {
                let self = this;
                console.log(type + "--" + no);
                let postData = {};
                let path = '';
                //
                switch(type) {
                    case voucherType.DEVC_REQR :
                        // ---------------- 设备请求 ---------------------
                        console.log("设备请求");

                        break;
                    case voucherType.DEAL_INQRY :
                        // 询盘单
                        console.log("询盘单");
                        //
                        postData.no = no;
                        path = SwbDealInqryVoucherList.path;
                        //
                        break;
                    case voucherType.DEAL_REPLY :
                        // 报盘单
                        console.log("报盘单");
                        // 供应商、服务商。注 ： 报盘 ，申请、审核、发布 未发送站内信！ 零售商不存在报盘！！
                        break;
                    case voucherType.PRICE_INQRY :
                        // 询价单
                        console.log("询价单");
                        //
                        break;
                    case voucherType.PRICE_REPLY :
                        //  -------------- 报价单 ----------------
                        console.log("报价单");
                        //
                        postData.inqryVoucherNo = no;
                        path = SwbPriceReplyList.path;
                        break;
                    case voucherType.CALL_BID :
                        // 招标书
                        console.log("招标书");
                        //
                        break;
                    case voucherType.TEND_BID :
                        // 投标书
                        console.log("投标书");
                        //
                        postData.no = no;
                        path = SwbBidDocList.path;
                        break;
                    case voucherType.CONTRACT :
                        // ----------------- 合同 -----------------
                        console.log("合同");
                        console.log(data);
                        //
                        postData.no = no;
                        if(data.indexOf('{') >= 0) {
                            let jsonData = JSON.decode(data);
                            let contractType = jsonData.contractType;
                            if(getEnumInfoWith("contractType", "name", "ServcPurch").value === contractType) {    // 服务采购合同
                                //
                                path = SwbServcPurchContractList.path;
                            } else if(getEnumInfoWith("contractType", "name", "IntegPurch").value === contractType) {    // 集成采购合同
                                //
                                path = SwbIntegPurchContractList.path;
                            } else if(getEnumInfoWith("contractType", "name", "ServcDlgt").value === contractType) {    // 服务授权合同
                                // 供应商
                                path = SwbServcDlgtContractList.path;
                            } else {
                                MsgBox.warning("合同类型信息异常！");
                                return;
                            }
                        } else {
                            MsgBox.warning("合同站内信内容信息异常！");
                            return;
                        }
                        //
                        break;
                    case voucherType.GOODS_ORDER :
                        // 商品订单
                        console.log("商品订单");
                        // 商品订单没有站内信
                        break;
                    case voucherType.GOODS_SHIP :
                        // ---------------- 发货单 ----------------
                        console.log("发货单");
                        // 发货 没有发送站内信
                        postData.no = no;
                        path = SwbGoodsShipVoucherList.path;
                        break;
                    case voucherType.GOODS_RECV :
                        // 收货单
                        console.log("收货单");
                        // 确认收货 未发送站内信
                        break;
                    case voucherType.SERVC_REQR :
                        // --------------------- 服务请求单 -------------------------
                        console.log("服务请求单");
                        //
                        postData.no = no;
                        path = SwbServcReqVoucherList.path;
                        break;
                    case voucherType.SERVC_ORDER :
                        // 服务订单
                        console.log("服务订单");
                        //
                        postData.no = no;
                        path = SwbServcOrderTradeList.path;
                        // 服务订单没有 发送站内信
                        break;
                    case voucherType.SERVC_WORK :
                        // 服务派工单
                        console.log("服务派工单");
                        if(data.indexOf('{') >= 0) {
                            let jsonData = JSON.decode(data);
                            let transOrgFlag = jsonData.transOrgFlag;
                            let servicerShopName = jsonData.servicerShopName;
                            if(transOrgFlag === 'true') {
                                //
                                MsgBox.warning("该单据为跨组织架构信息， 请登录 ：" + servicerShopName + "查看！");
                                return;
                            } else {
                                postData.no = no;
                                path = SwbServcWorkVoucherList.path;
                            }
                        } else {
                            MsgBox.warning("站内信内容信息异常！");
                            return;
                        }
                        //
                        break;
                    case voucherType.PAY_VOUCHER :
                        // ----------------------- 收款单据 （支付单据） ----------------
                        console.log("收款单据");
                        //
                        postData.no = no;
                        path = SwbRcvVoucherList.path;
                        //
                        break;
                    case voucherType.REFUND_VOUCHER :
                        // -------------------- 退款单据 --------------------
                        console.log("退款单据");
                        //
                        postData.no = no;
                        path = SwbRefundVoucherList.path;
                        //
                        break;
                    default:
                        MsgBox.warning('单据类型异常！');
                }
                //
                if(!Utils.isNoB(path)) {
                    let hashUrl = Utils.makeUrl(path, postData);
                    openPageRouteUrl(null, "/bench/home", hashUrl);
                }
            },
            //
            showImg: function (url) {
                Utils.setPageUrl(url, '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/msg/ReceiverMsgList.vue